// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"43ec8105","372":"69524dab","500":"bf5be506","592":"2dc858ae"}[chunkId] + ".chunk.js";
};